export default __webpack_public_path__ + "static/media/200.c9b26bc1.png";